import Head from "next/head"; 
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import Hidden from '@material-ui/core/Hidden'; 
import Typography from '../components/typography';
import Avatar from '@material-ui/core/Avatar';
import Container from '@material-ui/core/Container';  
import AppBar from "../components/appBar";
import Footer from "../components/footer";
import WidgetWa from "../components/widgetWa"; 
import useStyles from '../styles/aboutUsStyle';


export default function Nosotros() {

  const classes = useStyles();

  return (
    <>
     <Head>
        <title>Nosotros</title>
        <link rel="icon" href="/favicon.ico" /> 
        <meta charSet="utf-8" />
        <meta itemProp="description" content="Conozca al equipo de CIDU S.A.S y el papel que desempeñan."/>
        <link rel="canonical" href="https://cidu.com.co/nosotros" />
        <meta name="viewport" content="initial-scale=1.0, width=device-width" />
      </Head> 
      <Grid>
        <AppBar/> 
        <Grid className={classes.root} >
          <div className={classes.backgrounplans} />
            <Grid container  justify="center" alignItems="center" >
                <Grid item xs={11}>
                  <Paper  elevation={7} className={classes.paperContent}>
                    <Container  className={classes.containertittle}>
                        <Grid container
                            direction="column"
                            justify="space-between"
                            alignItems="center"
                            className={classes.gridtittle}>
                              <Grid item xs={12}  >
                                  <Typography variant="h3" marked="center" align="center" component="h1" className={classes.tittleservicepage}>
                                    NOSOTROS
                                  </Typography>
                                  <Typography variant="h6" align="justify"  component="p"  className={classes.subtittleservicepage}>
                                  <span className={classes.subtittleservicepagebold} >CONSULTORÍA DE INGENIERÍA & DESARROLLO URBANO S.A.S.</span>, esta 
                                  comprometida con el cumplimiento de las necesidades y 
                                  expectativas de todas nuestras partes interesadas, mediante el ofrecimiento de análisis técnicos y normativos precisos
                                  y veraces, partiendo de mecanismos de análisis técnicos, jurídicos y normativos robustos, generando así 
                                  valoración de predios y activos bajo análisis económicos exactos y lineamientos normativos que se estipulan 
                                  para el sector; para lo cual contamos con el personal idóneo y especializado, con la capacidad de prestar un 
                                  servicio de soporte pos venta que permita generar bienestar a la comunidad, permitiendo de esta manera  ser 
                                  reconocidos en el mercado y generar alto nivel de recomendación de nuestros servicios entre los clientes, 
                                  incrementando así la participación en el mercado y la rentabilidad como negocio, además de fortalecer la 
                                  cultura de mejora continua en los procesos de la cadena de valor, permitiendo integrar a los procesos 
                                  herramientas de punta especializadas y así generar valor sobre los entregables de los servicios prestados.
                                  </Typography>
                                  <Typography variant="h6" align="left"  component="p"  className={classes.subtittleservicepage}>
                                  De igual manera, los directivos de la empresa cuentan con los siguientes registros y certificaciones:
                                  </Typography>
                                  <Typography variant="h6" align="left"  component="p"  className={classes.subtittleservicepagebold}>
                                  REGISTRO ABIERTO DE AVALUADORES
                                  </Typography>
                                  <Typography variant="h6" align="left"  component="div"  className={classes.subtittleservicepageleft}> 
                                    <li>Inmuebles Urbanos</li>
                                    <li>Inmuebles Rurales</li>
                                    <li>Recursos Naturales y Suelos de Protección</li>
                                    <li>Obras de Infraestructura</li>
                                    <li>Edificaciones de Conservación Arqueológica y Monumentos Históricos </li>
                                    <li>Inmuebles Especiales</li>
                                    <li>Maquinaria Fija, Equipos y Maquinaria Móvil</li>
                                    <li>Maquinaria y Equipos Especiales</li>
                                    <li>Obras de Arte, Orfebrería, Patrimoniales y Similares</li>
                                    <li>Semovientes y Animales</li>
                                    <li>Activos Operacionales y Establecimientos de Comercio</li>
                                    <li>Intangibles</li>
                                    <li>Intangibles Especiales</li> 
                                  </Typography>
                                  <Typography variant="h6" align="left"  component="p"  className={classes.tittleservicepagebold}>
                                  CERTIFICACIÓN INTERNACIONAL COMO AUDITOR INTERNO NORMA ISO-19011 
                                  </Typography>
                                  <Typography variant="h6" align="left"  component="p"  className={classes.subtittleservicepage}>
                                  Certificación emitida por TUV Rheinland y el Centro Iberoamericano de estudios internacionales, avalado por la ONAC (Organización Nacional de Acreditación en Colombia) y por el Centro de Acreditación Alemán DAKKS – Deutsche Akkreditierungsstelle. 
                                  </Typography>
                                  <Typography variant="h6" align="left"  component="p"  className={classes.tittleservicepagebold}>
                                  CERTIFICACIÓN INTERNACIONAL COMO AUDITOR INTERNO EN SISTEMA DE GESTIÓN DE TECNOLOGÍA DE LA INFORMACIÓN ISO 20000:2011 
                                  </Typography>
                                  <Typography variant="h6" align="left"  component="p"  className={classes.subtittleservicepage}>
                                  Certificación emitida por Bureau Veritas. 
                                  </Typography>
                                  <Typography variant="h6" align="left"  component="p"  className={classes.tittleservicepagebold}>
                                  CERTIFICACIÓN INTERNACIONAL COMO AUDITOR INTERNO EN SISTEMA DE GESTIÓN DE CALIDAD ISO: 9001:2015 
                                  </Typography>
                                  <Typography variant="h6" align="left"  component="p"  className={classes.subtittleservicepage}>
                                  Certificación emitida por ICONTEC. 
                                  </Typography>
                                </Grid>                    
                          </Grid>
                    </Container>
                            
                            
                    <Container maxWidth={false} className={classes.ContainerServiceOne}>                
                      <Grid container  justify="center" direction="column">
                        <Grid item>
                          <Typography variant="h4" className={classes.titlefeature} >
                              AFILIACIÓN
                          </Typography>
                        </Grid>

                        <Grid container
                            direction="row"
                            justify="space-around"
                            alignItems="stretch">
                        <Hidden smDown>
                          <Grid item 
                              container
                              direction="row"
                              justify="center"
                              alignItems="center" xs={11} md={3}> 
                              <img  alt="avalua" src={"/images/us/avaluablanco.png"} className={classes.avaluaImage} draggable="false"/> 
                          </Grid>
                        </Hidden>
                        <Grid item container direction="column" justify="space-evenly" xs={11}  md={8} className={classes.gridfeature}>
                          <Typography variant="h5" align="left" className={classes.textpei}>
                          Asociación de Avaluadores Profesionales y Lonja Inmobiliaria de Colombia
                          </Typography>
                          <Typography variant="h6" align="left" className={classes.textpei}>
                            <span className={classes.subtitleteambold} >CONSULTORÍA DE INGENIERÍA & DESARROLLO URBANO S.A.S.</span>,
                            se encuentra inscrita en la Asociación de Avaluadores Profesionales y Lonja Inmobiliaria de 
                            Colombia -AVALUA, desde el doce (12) de febrero de dos mil diecisiete (2017). (Certificado Anexo)
                          </Typography>
                          <Typography variant="h6" align="left" className={classes.textpei}>
                              <a  href={"/docs/AFILIACION-LONJA-CIDU-SAS.pdf"} 
                                  target="_blank" 
                                  underline="none"
                                  rel="noopener noreferrer"
                                  className={classes.textlink}>Ver Certificado </a>
                          </Typography>
                        </Grid>           
                      </Grid>   
                    </Grid>
                  </Container>
                            
                            
                  <Container maxWidth={false} className={classes.ContainerServiceTwo}>       
                      <Grid container  justify="center" direction="column" className={classes.gridpei}>
                        <Grid container
                            direction="row"
                            justify="space-around"
                            alignItems="stretch">
                          <Hidden smDown>
                            <Grid item 
                                container
                                direction="row"
                                justify="center"
                                alignItems="center" xs={12}  md={4}>
                              <Avatar alt="Misión" variant="square" src={"/images/us/mision.jpg"} className={classes.avatarImage} imgProps={{ draggable: 'false'}}/>
                            </Grid>
                          </Hidden>
                          <Grid item container direction="column" justify="space-evenly" xs={11}  md={8} className={classes.gridfeature}>
                            <Typography variant="h5" align="left" className={classes.textpei}>
                                MISIÓN
                            </Typography>
                            <Typography variant="h6" align="left" className={classes.textpei}>
                              Prestar servicios de valoración y consultoría de ingeniería para desarrollo urbano 
                              en todo el territorio nacional, mediante la generación de análisis normativos robustos, 
                              lo que permite ofrecer un servicio de alta calidad que impacte positivamente todas las partes 
                              implicadas, proporcionando de esta manera a nuestros clientes, servicios que cumplan con sus 
                              expectativas generando así información confiable para tomar decisiones efectivas.
                            </Typography>
                          </Grid>           
                        </Grid>  
                      </Grid>

                      <Grid container  justify="center" direction="column" className={classes.gridpei}>         
                        <Grid container
                            direction="row"
                            justify="space-around"
                            alignItems="stretch">
                          <Grid item container direction="column" justify="space-evenly" xs={11}  md={8} className={classes.gridfeature}>
                            <Typography variant="h5" align="right" className={classes.textpei}>
                                VISIÓN
                            </Typography>
                            <Typography variant="h6" align="right" className={classes.textpei}>
                              En el 2025 posicionar a CIDU S.A.S como la empresa líder en el sector de prestación
                              de servicios de valoración y desarrollo urbano, siendo reconocida por 
                              la alta calidad de los servicios prestados, los cuales son ejecutados por 
                              procesos eficientes y un equipo de talento humano enfocado en sobrepasar las 
                              expectativas de sus clientes y cumplir detalle los requerimientos normativos.
                            </Typography>
                          </Grid>
                          <Hidden smDown>
                            <Grid item 
                                container
                                direction="row"
                                justify="center"
                                alignItems="center" xs={12} md={4}>     

                              <Avatar alt="Visión Imagen" variant="square" src={"/images/us/vision.jpg"} className={classes.avatarImage} imgProps={{ draggable: 'false'}}/>       
                            </Grid> 
                          </Hidden>
                        </Grid>  
                      </Grid>
                    </Container>


                    <Container maxWidth={false} className={classes.ContainerServiceTree}>      
                      <Grid container  justify="center" direction="column" className={classes.gridpei}>
                        <Grid container
                            direction="row"
                            justify="space-around"
                            alignItems="stretch"> 
                            <Grid item container direction="column" justify="space-evenly" xs={11}  md={10} className={classes.gridfeature}>
                              <Typography variant="h4" align="center" className={classes.titleteam}>
                                  EQUIPO
                              </Typography>
                              <Typography variant="h6" align="justify" className={classes.subtitleteam}>
                              <span className={classes.subtitleteambold} >CONSULTORÍA DE INGENIERÍA & DESARROLLO URBANO S.A.S.</span>, cuenta con un 
                              equipo de profesionales adscritos, en donde podemos encontrar Ingenieros catastrales y geodestas, industriales, 
                              mecánicos, topográficos, ambientales, forestales, civiles, de sistemas, arquitectos, abogados y contadores públicos.
                              </Typography>
                              <Typography variant="h6" align="justify" className={classes.subtitleteam}>
                              Profesionales con estudios de postgrado en avalúos. Estudios en sistemas de información geográfica, planeación, 
                              medio ambiente, economía y gerencia de proyectos.
                              </Typography>
                              <Typography variant="h6" align="justify" className={classes.subtitleteam}>
                              Manejo de software especializados en cartografía digital y de base de datos, diseño, procesos industriales. 
                              Productos terminados en formato digital.
                              </Typography>
                              <Typography variant="h6" align="justify" className={classes.subtitleteamgrid}>
                              Participación en talleres y seminarios de actualización en técnicas y temas afines al sector 
                              inmobiliario y de la construcción, procesos industriales, normas internacionales de información contable 
                              y financiera NIC-NIIF.
                              </Typography>
                            </Grid>           
                        </Grid>  
                      </Grid>

                      <Grid container direction="column" justify="center"   className={classes.gridpei}>          
                                    
                        <Grid container
                            direction="row"
                            justify="space-evenly"
                            alignItems="flex-start">
                                

                          <Grid item
                              container
                              direction="row"
                              justify="center"
                              alignItems="center"
                              xs={10}  md={6}
                              className={classes.gridteam}>
                              
                            <Grid item>
                              <Avatar alt="Visión Imagen"  src={"/images/ceo/jonathan.jpeg"} className={classes.teamember} imgProps={{ draggable: 'false'}}/>                       
                            </Grid>
                            <Grid item
                                container
                                direction="column"
                                justify="center"
                                alignItems="stretch"
                                xs={11} sm={7} lg={8}>
                                <Typography variant="h5" align="left" className={classes.textteam} >
                                Jonathan Ortiz Castaño
                                </Typography>
                                <Typography variant="h6" align="left" className={classes.textteam}>
                                    Director General
                                </Typography>
                                <Typography variant="body1" align="left" className={classes.contentteam}>
                                Ingeniero Catastral y Geodesta, Especialista en avalúos.
                                </Typography> 
                            </Grid>
                          </Grid>

                          <Grid item
                            container
                            direction="row"
                            justify="center"
                            alignItems="center"
                            xs={10} md={6}
                            className={classes.gridteam}>
                            <Grid item >
                                <Avatar alt="Visión Imagen"  src={"/images/ceo/carolina.jpeg"} className={classes.teamember} imgProps={{ draggable: 'false' }}/>  
                            </Grid>
                            <Grid item
                              container
                              direction="column"
                              justify="center"
                              alignItems="stretch"
                              xs={11} sm={7} lg={8}>
                              <Typography variant="h5" align="left"  className={classes.textteam}>
                              Carolina Rodriguez Potier
                              </Typography>
                              <Typography variant="h6" align="left"  className={classes.textteam}>
                                  Directora Administrativa
                              </Typography>
                              <Typography variant="body1" align="left"  className={classes.contentteam}>
                                  Ingeniera Industrial, Especialista en Gerencia Integral de Calidad.
                              </Typography>
                            </Grid>
                          </Grid>
                        </Grid>
                      </Grid>
                    </Container>
                  </Paper>
                </Grid>
            </Grid>
        </Grid>
        <Footer/>
      </Grid>
      <WidgetWa link={'https://wa.me/573014606980/?text=Hola%20CIDU,%20quiero%20contactarme%20con%20Ustedes!'}/>
    </>
  );
};

 